import React, { Fragment, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';
import { getCotationsByParams, deleteCotation } from '../../actions/cotation';
import ResultatItem from './ResultatItem';
import { useTranslation } from 'react-i18next';

const CotationList = ({
  getCotationsByParams,
  deleteCotation,
  cotation: { cotations, loading },
  auth
}) => {
  const { t } = useTranslation();

  const emplacement = useLocation();
  const { pathname } = emplacement;
  // On récupère tous les pathnames jusqu'au modèle, dans notre cas nous en récupérons 4 : "/#/resultat/marque/modele", en précisant que chaque pathname est séparé par un "/".
  // Attention, veuillez bien laisser les deux virgules afin que cela puisse correctement récupérer la marque et le modèle au bon endroit sur l'url.
  const [, , marque, modele] = pathname.split('/');

  useEffect(() => {
    getCotationsByParams(
      marque !== 'null' ? marque : undefined,
      modele !== 'null' ? modele : undefined,
      undefined,
      undefined,
      undefined
    );
    console.log(modele);
  }, [getCotationsByParams, marque, modele]);

  const EffacementCotation = (ID) => {
    if (
      window.confirm(
        'Etes vous sur ? Cette opération ne peut pas être annulée !'
      )
    ) {
      deleteCotation(ID);
      setTimeout(() => {
        window.location.reload();
      }, 3000); //runs after 5sec
    }
  };

  if (loading) {
    return <Spinner />;
  } else if (cotations === null || cotations.length === 0) {
    return (
      <div style={{ marginTop: 100, marginBottom: 50 }}>
        <h3 className="text-center">Aucune cotations n'a été trouvée</h3>
      </div>
    );
  } else {
    return (
      <section className="container">
        <Fragment>
          <div style={{ marginTop: 50, marginBottom: 50 }}>
            <h2 className="p-3 mb-2 bg-ascorel text-white text-center">
              Resultats recherche :{' '}
              {marque !== 'null' ? decodeURIComponent(marque) + ' / ' : ''}{' '}
              {modele !== 'null' ? decodeURIComponent(modele) + ' / ' : ''}{' '}
            </h2>

            <table
              className="table text-nowrap table-striped table-light table-header-group table-container"
              border="1"
            >
              <thead>
                <tr className="sticky">
                  <th className="text-center" id="th2"></th>

                  <th className="text-center" id="th3" width="100">
                    {t('date')}
                  </th>
                  <th className="text-center " id="th5">
                    {t('manufacturer')}
                  </th>
                  <th className="text-center" id="th6">
                    {t('model')}
                  </th>
                  <th className="text-center" id="serie">
                    {t('version')}
                  </th>
                  <th className="text-center" id="serie">
                    {t('generation')}
                  </th>
                  <th className="text-center" id="serie">
                    {t('author')}
                  </th>
                  <th className="text-center" id="btn_effac"></th>
                </tr>
              </thead>
              <tbody>
                {cotations.map((cotation, index) => (
                  <ResultatItem
                    key={cotation._id}
                    cotation={cotation}
                    index={index}
                    deleteCotation={() => EffacementCotation(cotation._id)}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </Fragment>
      </section>
    );
  }
};

CotationList.propTypes = {
  getCotationsByParams: PropTypes.func.isRequired,
  deleteCotation: PropTypes.func.isRequired,
  cotation: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  cotation: state.cotation,
  auth: state.auth
});

export default connect(mapStateToProps, {
  getCotationsByParams,
  deleteCotation
})(CotationList);
